import React from 'react';
import Link from '@/links';
import {withBoldWeight, withUnderline} from '@/hocs/withFontType';

const BoldSpan = withBoldWeight('span');
const Underline = withUnderline('span');

const TAG_REGEX =
  /<bold>([\s\S]*?)<\/bold>|<u>([\s\S]*?)<\/u>|<a href="([^"]*)"(?: target="([^"]*)")?>([\s\S]*?)<\/a>|<br><\/br>/g;

/**
 * Parses `<bold>...</bold>`, `<u>...</u>`, `<a href="..." target="...">...</a>` and `<br></br>` markers
 * embedded in plain translated strings (pulled via `t.raw()`, where next-intl's own
 * `t.rich()` isn't usable because the string isn't addressed by its own message key) into
 * React nodes. `target` is optional and is forwarded when present.
 */
export function parseLegalRichText(text) {
  if (!text) return text;

  const matches = [...text.matchAll(TAG_REGEX)];
  const nodes = [];
  let lastIndex = 0;

  matches.forEach((match, index) => {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    if (match[0] === '<br></br>') {
      nodes.push(<br key={index} />);
    } else if (match[1] !== undefined) {
      nodes.push(<BoldSpan key={index}>{match[1]}</BoldSpan>);
    } else if (match[2] !== undefined) {
      nodes.push(<Underline key={index}>{match[2]}</Underline>);
    } else {
      nodes.push(
        <Link key={index} href={match[3]} target={match[4]} variant="default">
          {match[5]}
        </Link>
      );
    }
    lastIndex = match.index + match[0].length;
  });
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }
  return nodes;
}
